import React from 'react';
import imageSrc from '../../assets/about.jpeg'; // Import your image here
import "../../styles/AboutUs.css"
import Navbar from '../../layouts/Navbar';
import Footer from "../../layouts/Footer"
const AboutUs = () => {
  return (
   <div>
<Navbar/>
    <div className="about-us-container">
 
      <div className="image-container">
        <img src={imageSrc} alt="About Us" className="about-us-image" />
      </div>
      <div className="text-container">
        
        <h2>About Us</h2>
        <p>
        yelospace is an early-stage platform helping tenants sublet unused space.
        </p>
        
      </div>
    </div>
    <Footer/>
   </div>
  );
};

export default AboutUs;

